import { useEffect, useRef, useState } from 'react';

import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

export const PdfViewer = ({ pdfUrl }: { pdfUrl: string }) => {
  const [, setNumPages] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const loadPdf = async () => {
    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    setNumPages(pdf.numPages);

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      renderPage(pdf, pageNum);
    }
  };

  const renderPage = async (pdf: pdfjsLib.PDFDocumentProxy, pageNumber: number) => {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale: 1.5 });

    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.display = 'block';
    canvas.style.margin = 'auto';

    const context = canvas.getContext('2d');
    if (!context) return;

    const renderContext = { canvasContext: context, viewport, canvas };
    await page.render(renderContext).promise;

    if (containerRef.current) {
      containerRef.current.appendChild(canvas);
    }
  };

  useEffect(() => {
    loadPdf();
  }, [pdfUrl]);

  return <div ref={containerRef} className="h-[85vh] overflow-y-auto border border-gray-200 p-4" />;
};
